<template>
    <div class="columns">
        <div class="column">
						<div v-if="step === 1">

								<div class="field">
                    <div class="columns">
                        <div class="column is-4">
                            <p>Выберите тур на который будут добавляться критерии</p>
                            <select v-model="tour" @change="step = 2; getData()">
                                <option value="NULL">Все туры</option>
                                <option value="0">Отборочный тур</option>
																<option value="1">Лонг-лист</option>
                                <option value="2">Шорт-лист</option>
                                <option value="2">Победители</option>
                            </select>
												</div>
                    </div>

								</div>
						</div>
						<div v-if="step === 2">
                <div v-if="!isLoading">
										<p><a @click="step = 1">К выбору тура</a></p>
										<p>{{ tourName }}</p>
                    <p>
                        <button @click="criterion_id='';showModal()" class="button4">Добавить</button>
                    </p>

                    <table class="table">
                        <thead>
                        <tr>
                            <th>Название</th>
                            <th>Действия</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(criterion,index) in criterions" :key="index">
                            <td>{{ criterion.name }}</td>
                            <td>
                                <a @click.prevent="editCriterion(criterion.id)"
                                   style="display: inherit; cursor: pointer; margin-right: 10px;"><i
                                        class="far fa-edit"></i></a>
                                <a @click.prevent="deleteCriterion(criterion.id)" style="display:inherit; cursor: pointer; margin-right: 0;" class="delete_link"><i class="far fa-trash-alt"></i></a>
                            </td>
                        </tr>
                        </tbody>
                    </table>

                    <Modal width="80%"
                           v-model:visible="modal_visible"
                           :footer="null"
                           :destroyOnClose="true"
                           :afterClose="getData"
                    >
                        <CriterionItem
                                :criterion_id="criterion_id"
                                :category_id="categoryId"
                                :category_name="category.name"
																:tour="tour"
                                @closeModal="getData(); modal_visible = false;"
                        ></CriterionItem>
                    </Modal>
                </div>
                <div v-else>
                    <Spin></Spin>
                </div>
						</div>
        </div>
    </div>
</template>

<script>

import BaseLoader from "@/components/Base/BaseLoader.vue";
import axios from "axios"
import BaseInput from "@/components/Base/BaseInput3.vue";
import BaseTextarea from "@/components/Base/BaseTextarea.vue";
import CriterionItem from "@/components/CriterionItem.vue";
import {Modal, Spin} from 'ant-design-vue';

export default {
  name: 'CriterioComponent',
  data() {
    return {
      isLoading: false,
      category: '',
      criterion_id: '',
      criterions: [],
      modal_visible: false,
			step: 1,
			tour: ''
    }
  },
  components: {
    BaseTextarea,
    BaseInput,
    BaseLoader,
    Spin,
    Modal,
    CriterionItem
  },
  mounted: function () {
    if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
      alert("Эта страница может работать некорректно в браузере Safari. Рекомендуемые браузеры Яндекс.Браузер или Google Chrome.");
    }
    //this.getData();
  },
  computed: {
    categoryId() {
      return window.categoryId;
    },
    criterionId() {
      return window.criterionId;
    },
		tourName() {
      if (this.tour === 'NULL') {
        return 'Для всех туров';
			} else if (this.tour === '1') {
        return 'Лонг-лист';
			} else if (this.tour === '2') {
        return 'Шорт-лист';
      } else if (this.tour === '3') {
        return 'Победители';
      }
      return ''
    }
  },
  methods: {
    async getData() {
      this.isLoading = true;
			//let url = '/api/vote_criterions.json?competition_category.id=' + this.categoryId + '&exists[tour]=false';
      let url = '/getCriterionByCategoryAndTour/' + this.categoryId;
      
      console.log(this.tour);
      
      if (this.tour !== 'NULL') {
        url = '/getCriterionByCategoryAndTour/' + this.categoryId + '/' + this.tour;
        //url = '/api/vote_criterions.json?competition_category.id=' + this.categoryId + '&tour='+this.tour;
			}
      const criterias = await axios.get(url);
      this.criterions = criterias.data;

      const item = await axios.get('/api/categories/' + this.categoryId + '.json');
      this.category = item.data;

      this.isLoading = false;
    },
    showModal() {
      this.modal_visible = !this.modal_visible;
    },
    async editCriterion(id) {
      this.criterion_id = id;
      this.showModal()
    },
		async deleteCriterion(id) {
			await axios.delete('/api/vote_criteria/' + id)
			this.getData();
		}
  },

}
</script>

<style scoped>

</style>
